export const enum UserDataFormFields {
  PHONE = 'phone',
  BIRTHDATE = 'birthdate',
}

export type TUserDataFormValues = {
  [UserDataFormFields.PHONE]?: string,
  [UserDataFormFields.BIRTHDATE]?: string,
}
